<template>
  <div class="d-flex flex-column text-center">
    <span class="text-overline ma-8">{{
      $vuetify.lang.t("$vuetify.worksheet.chooseSupplier")
    }}</span>

    <vehicle-select v-model="companyVehicle" companyType="SUPPLIER"/>

    <div
      class="d-flex justify-start flex-column font-weight-bold"
      v-if="companyVehicle"
    >
      <div>
        {{ $vuetify.lang.t("$vuetify.worksheet.supplierName") }}:
        {{ companyVehicle.companyName }}
      </div>
      <div>
        {{ $vuetify.lang.t("$vuetify.worksheet.plateNumber") }}:
        {{ companyVehicle.vehicleLicensePlate }}
      </div>
      <div v-if="companyVehicle.vehicleNotes">
        {{ $vuetify.lang.t("$vuetify.base.notes") }}:
        {{ companyVehicle.vehicleNotes }}
      </div>
    </div>

    <div class="d-flex justify-center mx-2 my-8">
      <v-btn :disabled="worksheet.status == 'USED'" @click="updateWorksheet(worksheet)" color="primary">{{
        $vuetify.lang.t("$vuetify.base.update")
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const VehicleSelect = () =>
  import("@/components/companyVehicle/VehicleSelect.vue");
import { getCompanyVehicle } from "@/services/companyVehicle";

export default {
  props: {
    worksheet: {
      type: Object,
      required: true,
    },
    weightUnit: {
      type: String,
      required: false,
      default: 'Kg'
    }
  },
  data: () => {
    return {
      supplierId: null,
      companyVehicle: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    ...mapGetters("company", ["suppliers"]),

    hasEntries() {
      return this.worksheet.entries && this.worksheet.entries.length > 0;
    },
  },
  components: {
    VehicleSelect,
  },
  created() {
    this.vehicleId = this.worksheet.vehicleId;
    this.loadVehicle(this.vehicleId);
  },
  methods: {
    ...mapActions("processWorksheet", [
      "updateProcessWorksheet",
      "deleteProcessWorksheet",
    ]),
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),

    updateWorksheet(worksheet) {
      if(this.companyVehicle){
        worksheet.supplierId = this.companyVehicle.companyId;
        worksheet.supplierName = this.companyVehicle.companyName
        worksheet.vehicleId = this.companyVehicle.id;
      }

      const payload = Object.assign({}, worksheet);
      delete payload.files;
      this.updateProcessWorksheet(payload);

      this.$emit("update:worksheet", worksheet);
      this.$emit("updated", worksheet);
    },
    async loadVehicle(id) {
      if (id && id > 0) {
        return await getCompanyVehicle(id)
          .then((response) => {
            this.companyVehicle = response.data;
          })
          .catch(() => {
            this.addErrorMessage("Error loading supplier");
          });
      }
    },
    
  },
};
</script>

<style></style>
